import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  CircularProgress,
} from '@mui/material';
import {
  ArrowBack,
  EmojiEvents,
} from '@mui/icons-material';

const RankingPage = () => {
  const navigate = useNavigate();
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRanking();
  }, []);

  const fetchRanking = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ranking`);
      setRanking(response.data);
    } catch (error) {
      console.error('Error fetching ranking:', error);
    } finally {
      setLoading(false);
    }
  };

  const getMedalColor = (position) => {
    switch (position) {
      case 1:
        return '#FFD700';
      case 2:
        return '#C0C0C0';
      case 3:
        return '#CD7F32';
      default:
        return 'transparent';
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <EmojiEvents sx={{ mr: 1 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Ranking de Mentores
          </Typography>
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Top Mentores
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Posición</TableCell>
                  <TableCell>Mentor</TableCell>
                  <TableCell align="right">Puntaje Total</TableCell>
                  <TableCell align="right">Exámenes</TableCell>
                  <TableCell align="right">Promedio</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ranking.map((student, index) => (
                  <TableRow
                    key={student.id}
                    sx={{
                      backgroundColor: index < 3 ? `${getMedalColor(index + 1)}20` : 'inherit',
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {index < 3 && (
                          <EmojiEvents sx={{ color: getMedalColor(index + 1) }} />
                        )}
                        <Typography fontWeight="bold">#{index + 1}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                          {student.name.charAt(0)}
                        </Avatar>
                        <Typography>{student.name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Chip label={student.totalScore} color="primary" />
                    </TableCell>
                    <TableCell align="right">{student.examsCompleted}</TableCell>
                    <TableCell align="right">
                      {student.averageScore.toFixed(1)}%
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Box>
  );
};

export default RankingPage;
